import { PipeTransform, Pipe } from "@angular/core";
// import * as moment from 'moment';

@Pipe({
  name: 'LocalDateTimestamp'
})
export class LocalDateTimestamp implements PipeTransform {
  transform(time: any): string {
    const date = new Date(time);
    const dataFormatada = date.toLocaleDateString('pt-BR');
    const tempoFormatado = date.toLocaleTimeString('pt-BR');
    return dataFormatada + ' ' + tempoFormatado;
}
}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/auditoria-caixa/local-date-timestamp.ts